import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "./../../../../../environments/environment";
import * as HSET from "./settings";
import { GenericHttpService } from "./../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';

const genericUtils = new GenericUtils();
@Injectable({
  providedIn: 'root'
})
export class DataService {
  baseUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService, public utils: GenericUtils) { }

  getData(url, config, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${url}`,
      query: params
    };

    const functionToExecute = this[config['functionToCall']].bind(this);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }


  processOutboundOverallSLA(data) {
    if (!data.data.length) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]];
    let dataToReturn = null;
    originalData.map((ele) => {
      if (ele['origin_region'] === "Total") {
        if (ele["eligible_quantity"] === 0 && ele["shipped_quantity"] === 0) {
          dataToReturn = null;
        } else {
          dataToReturn = { total: [Number(ele['sla'].toFixed(2))] };
        }
      }

    });
    return dataToReturn;
  }

  processFillRate(data: any) {
    if (!Object.keys(data.data).length) return null;

    let dataToReturn = null;
    const processed_qty = Object.keys(data.data).reduce((a, b) => a + data.data[b]['processed_qty'], 0);
    const ordered_qty = Object.keys(data.data).reduce((a, b) => a + data.data[b]['ordered_qty'], 0);
    const percentage = ((+processed_qty || 0) / (+ordered_qty || 0)) * 100 || 0;
    dataToReturn = { total: [+percentage.toFixed(2)] };
    if(!percentage) return null;
    return dataToReturn;
  }

  createChart(chartData, chartOptions) {
    const chart = this.utils.deepCopyFunction(chartOptions[0]);

    for (let i = 0; i < chartData.total.length; i++) {
      chart.series[0].data[i].y = chartData.total[i];
    };
    // chart.series[0].data = [];


    // for (let i = 0; i < chartData.dataPoints.length; i++) {
    //   const seriesData = {
    //     y: chartData.dataPoints[i],
    //     name: chartOptions[0].series.name[i],
    //     color: chartOptions[0].series.color[i],
    //     myData: chartData.formatterString
    //   }
    //   chart.series[0].data[i] = seriesData;

    // }
    return chart;
  }
}
